export const START_POST_UNIQUECOUPON_HOLDS_LOADING = 'REDUX_SAGA_START_POST_UNIQUECOUPON_HOLDS_LOADING';
export const START_POST_UNIQUECOUPON_HOLDS_SUCCESS = 'REDUX_SAGA_START_POST_UNIQUECOUPON_HOLDS_SUCCESS';
export const START_POST_UNIQUECOUPON_HOLDS_ERROR = 'REDUX_SAGA_START_POST_UNIQUECOUPON_HOLDS_ERROR';
export const START_POST_UNIQUECOUPON_HOLDS_RESET = 'REDUX_SAGA_START_POST_UNIQUECOUPON_HOLDS_RESET';
export const START_POST_UNIQUECOUPON_HOLDS_DELETE = 'REDUX_SAGA_START_POST_UNIQUECOUPON_HOLDS_DELETE';


export const actionPostUniqueCoupon = (dispatch, uniqueCoupon) => {
    dispatch({ type: START_POST_UNIQUECOUPON_HOLDS_LOADING, uniqueCoupon });
};

export const actionDeleteUniqueCoupon = (dispatch, UniqueCOuponHoldRef) => {
    dispatch({ type: START_POST_UNIQUECOUPON_HOLDS_DELETE, UniqueCOuponHoldRef });
}

export const actionResetUniqueCouponCardHoldState = (dispatch) => {
    dispatch({ type: START_POST_UNIQUECOUPON_HOLDS_RESET });
}